<template>
  <!-- <div v-if="this.user && this.loggedIn"> -->
  <div
    :class="
      this.$vuetify.breakpoint.smAndDown
        ? 'pt-0 staticheader'
        : 'py-3 staticheader'
    "
  >
    <v-navigation-drawer app v-model="drawer" disable-resize-watcher>
      <v-list>
        <v-list-item
          v-for="item in mobileItems"
          :key="item.title"
          :to="item.path"
          :replace="true"
        >
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar dense flat class="px-0" style="background-color: transparent;">
      <v-toolbar-title style="width:90px" class="hidden-sm-and-down ml-1">
        <v-img
          src="@/assets/images/logo.png"
          style="cursor:pointer;"
          @click="clearBooking"
        ></v-img>
      </v-toolbar-title>
      <v-app-bar-nav-icon
        class="hidden-md-and-up primary white--text"
        @click="drawer = !drawer"
        v-if="this.user && this.loggedIn"
      >
      </v-app-bar-nav-icon>
      <v-spacer />
      <v-img
        contain
        width="80px"
        height="40px"
        src="@/assets/images/logo.png"
        class="hidden-md-and-up mr-5"
        @click="clearBooking"
      ></v-img>
      <v-spacer />
      <CO2 v-if="this.user && this.loggedIn" />
      <!-- <ul
        :slot="$vuetify.breakpoint.mdAndUp ? 'extension' : null"
        class="hidden-sm-and-down pt-2"
        style="margin-top:-20px;"
        v-if="this.user && this.loggedIn"
      >
        <li
          v-for="item in items"
          :key="item.path"
          :slot="$vuetify.breakpoint.mdAndUp ? 'extension' : null"
          style="margin: 0px 50px 0px 0px;"
        >
          <router-link
            :to="item.path"
            :replace="item.path === 'history'"
            style="text-decoration:none;"
            tag="li"
            class="white--text"
          >
            {{ item.title }}
          </router-link>
        </li>
      </ul> -->
      <!-- :slot="$vuetify.breakpoint.mdAndUp ? 'extension' : null" -->
      <v-menu
        class="hidden-sm-and-down"
        offset-y
        left
        nudge-top="-10"
        v-if="this.user && this.loggedIn"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            :slot="$vuetify.breakpoint.mdAndUp ? 'extension' : null"
            class="staticheadericon hidden-sm-and-down pt-4 pb-5"
            style="cursor:pointer; font-size: 25px;"
            v-bind="attrs"
            v-on="on"
          >
            {{ userIcon }}
          </v-icon>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in userItems"
            :key="index"
            style="text-decoration:none; min-height: 30px !important; max-height: 30px !important; padding-bottom: 0px !important; margin-bottom: 0px !important;"
          >
            <router-link
              :to="item.path"
              :replace="item.path === 'history'"
              style="text-decoration:none;"
              class="ma-0 black--text"
            >
              {{ item.title }}
            </router-link>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar>
    <PromptResetBookingDialog
      :display="displayPromptResetBooking"
      :title="resetBookingTitle"
      :question="resetBookingQuestion"
      @accepted="resetBooking"
      @rejected="displayPromptResetBooking = false"
    />
  </div>
</template>

<script>
import CO2 from "../components/CO2.vue";
import { dictionary } from "../helpers";
import PromptResetBookingDialog from "@/components/dialogs/QuestionDialog.vue";

export default {
  name: "Header",
  components: {
    CO2,
    PromptResetBookingDialog
  },
  created() {
    this.updateMenuItems();
  },
  data: () => ({
    appTitle: "GLS Express Webbooking",
    drawer: false,
    items: [],
    mobileItems: [],
    userIcon: dictionary.mdi.user.info,
    userItems: [],
    displayPromptResetBooking: false,
    resetBookingTitle: dictionary.texts.reset.booking.title,
    resetBookingQuestion: dictionary.texts.reset.booking.question
  }),
  computed: {
    user: {
      get() {
        return this.$store.state.user.activeUser;
      }
    },
    loggedIn: {
      get() {
        return this.$store.state.authentication.status.loggedIn;
      }
    }
  },
  watch: {
    user() {
      this.updateMenuItems();
    }
  },
  methods: {
    updateMenuItems() {
      this.items = [];
      this.items.push({ title: "Booking", path: "/booking" });
      this.items.push({ title: "Historik", path: "/history" });
      // this.items.push({ title: 'Kontakt', path: '/Contact' });

      this.mobileItems = [];
      this.mobileItems.push({ title: "Booking", path: "/booking" });
      this.mobileItems.push({ title: "Historik", path: "/history" });
      this.mobileItems.push({ title: "Bruger", path: "/user" });
      this.mobileItems.push({ title: "Logud", path: "/" });

      this.userItems = [];
      this.userItems.push({ title: "Bruger", path: "/user" });
      this.userItems.push({ title: "Logud", path: "/" });
    },
    clearBooking() {
      if (this.user && this.loggedIn) {
        if (this.$route.path == "/booking") {
          this.displayPromptResetBooking = true;
        } else {
          this.$router.push("/booking");
        }
      }
    },
    resetBooking() {
      this.$store.commit("booking/resetBooking");
      this.displayPromptResetBooking = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import url("../assets/styles/colors.css");

.staticheader {
  /* background: linear-gradient(
    360deg,
    var(--GLS-blue-100) 0%,
    var(--gradient-blue) 143.9%
  ); */
  // background-color: var(--GLS-blue-100);
  // color: var(--GLS-white);
  max-width: 870px;
  margin: auto;
}

.staticheadericon {
  color: var(--GLS-white) !important;
  min-height: 45px;
  max-height: 45px;
}

ul {
  width: 100%;
  background-color: transparent;
  margin-inline-start: -20px;
}

li {
  display: inline;
  justify-content: space-between;
  align-items: bottom;
  background: transparent;
  padding: 0px 0px 5px 0px;
  border-bottom: 4px solid transparent;
  margin: 0px 0px 0px 0px;
}

li:hover,
// li.router-link-active,
li.router-link-exact-active {
  cursor: pointer;
  border-bottom-color: var(--GLS-yellow); //GLS Gelb
}
</style>
